import { standardAction, apiAction } from "@ROM-utils/actions";
import WarehousesApi from "./api";

export const LIST = "warehouses/api/LIST";
export const FIND = "warehouses/api/FIND";
export const CREATE = "warehouses/api/CREATE";
export const UPDATE = "warehouses/api/UPDATE";
export const DESTROY = "warehouses/api/DESTROY";
export const SET_PAGE = "warehouses/api/SET_PAGE";
export const LIST_WITH_SCROLL = "warehouses/api/LIST_WITH_SCROLL";
export const LIST_ALL = "warehouses/api/LIST_ALL";

export function list(options = {}) {
  return apiAction(LIST, WarehousesApi.list(options));
}

export function listAll(options = {}) {
  return apiAction(LIST_ALL, WarehousesApi.listAll(options));
}

export function find(id) {
  return apiAction(FIND, WarehousesApi.find(id));
}

export function create(attributes = {}) {
  return apiAction(CREATE, WarehousesApi.create(attributes));
}

export function update(id, attributes = {}) {
  return apiAction(UPDATE, WarehousesApi.update(id, attributes));
}

export function destroy(id) {
  return apiAction(DESTROY, WarehousesApi.destroy(id), { warehouseId: id });
}

export function setPage(page) {
  return standardAction(SET_PAGE, { page });
}

export function getFilteredWarehouses(filters, page) {
  return list({
    ...filters,
    page,
  });
}
